import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const ProductBreakdown = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Switch Biológico',
    desc: 'La ciencia del sueño de tu bebé. Por qué fallan las estrategias aleatorias.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Santuario del Sueño',
    desc: 'Oscuridad, ruido blanco, temperatura. El ambiente que hace que el sueño ocurra solo.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — El Reloj Maestro',
    desc: 'Ventanas de Sueño Dinámicas por edad. El timing que lo cambia todo.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Autonomía Gradual',
    desc: 'Cómo enseñarle a dormirse solo, de forma respetuosa. Sin llanto controlado.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — El Manual de Crisis',
    desc: 'Protocolo para las noches más difíciles. Regresiones, dentición, viajes. Sabés exactamente qué hacer.'
  }];
  const includes = ['Protocolo listo para aplicar esa noche', 'Tabla de ventanas por edad', 'Señales de cansancio real', 'Checklist de validación', 'Bitácora de seguimiento', 'FAQ completo'];
  return <section className="pt-4 md:pt-6 pb-8 md:pb-12 px-4 bg-navy-800/30" data-id="element-236">
      <div className="max-w-5xl mx-auto" data-id="element-237">
        <FadeIn data-id="element-238">
          <div className="text-center mb-10" data-id="element-239">
            <div className="inline-block bg-yellow-400/10 text-yellow-400 px-4 py-1 rounded-full text-xs font-bold tracking-wider mb-3 border border-yellow-400/30 shadow-[0_0_15px_rgba(250,204,21,0.2)]" data-id="element-240">
              EL SISTEMA COMPLETO
            </div>
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-2 drop-shadow-[0_2px_10px_rgba(255,255,255,0.1)]" data-id="element-241">
              🏆 MEGAPACK NOCHES DE PAZ
            </h2>
            <p className="text-base text-yellow-100/90 font-medium" data-id="element-242">
              5 Tomos + 5 Bonos — 0 a 36 meses
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-16" data-id="element-243">
            <div className="space-y-4" data-id="element-244">
              {tomos.map((tomo, index) => <div key={index} className="bg-navy-800/80 p-5 rounded-xl border border-navy-600 hover:border-yellow-400/40 hover:bg-navy-800 transition-all pt-[20px] pb-[20px] mt-[10px] mb-[10px] shadow-lg hover:shadow-[0_0_20px_rgba(250,204,21,0.1)] group" data-id="element-245">
                  <div className="flex items-start" data-id="element-246">
                    <span className="text-3xl mr-4 group-hover:scale-110 transition-transform origin-center" data-id="element-247">
                      {tomo.icon}
                    </span>
                    <div data-id="element-248">
                      <h3 className="text-xl font-bold text-white mb-2 group-hover:text-yellow-400 transition-colors" data-id="element-249">
                        {tomo.title}
                      </h3>
                      <p className="text-gray-200" data-id="element-250">{tomo.desc}</p>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="relative" data-id="element-251">
              <div className="absolute inset-0 bg-yellow-400/10 blur-[60px] rounded-full" data-id="element-252"></div>
            </div>
          </div>

          <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-navy-600 rounded-2xl p-8 md:p-10 pt-[0px] pb-[0px] shadow-2xl relative overflow-hidden" data-id="element-253">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-transparent via-yellow-400/50 to-transparent" data-id="element-254" />
            <h3 className="text-xl md:text-2xl font-serif font-bold text-center text-white mt-[24px] mb-[24px]" data-id="element-255">
              Cada tomo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mb-[24px]" data-id="element-256">
              {includes.map((item, index) => <div key={index} className="flex items-center space-x-3 bg-navy-900/80 border border-navy-700 p-4 rounded-lg hover:border-green-400/30 transition-colors" data-id="element-257">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(74,222,128,0.5)]" data-id="element-258" />
                  <span className="text-white font-medium" data-id="element-259">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};